import { useEffect, useState } from 'react';
import { FormGroup } from '../../../../../Components/FormGroup/FormGroup';
import QuestionSet from './QuestionSet';

function CheckBoxWithQuestion({ option, errors, register, defaultValue = {} }) {
  const [isChecked, setIsChecked] = useState(false);
  const [defaultOption, setDefaultOption] = useState({});

  useEffect(() => {
    if (defaultValue && defaultValue[option.id]) {
      setIsChecked(option.id);

      setDefaultOption(defaultValue[option.id]);
    }
  }, [defaultValue]);
  const handleThematicAreaChange = (e) => {
    e.target.checked ? setIsChecked(Number(e.target.id)) : setIsChecked(false);
  };

  return (
    <div>
      <FormGroup
        type="checkbox"
        id={`thematic_area[${option.id}]`}
        options={[option]}
        register={register}
        onChange={(e) => handleThematicAreaChange(e)}
        error={errors}
        key={defaultValue}
        // defaultValue={defaultValue.thematic_area ? 'false' : ''}
        errorName="At least one thematic"
        checked={isChecked}
      />

      <QuestionSet
        register={register}
        errors={errors}
        id={option.id}
        defaultOption={defaultOption}
        isChecked={isChecked}
      />
    </div>
  );
}

export default CheckBoxWithQuestion;
